// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ScatterSvg from '@rsuite/icon-font/lib/charts/Scatter';
var Scatter = createSvgIcon({
  as: ScatterSvg,
  ariaLabel: 'scatter',
  category: 'charts',
  displayName: 'Scatter'
});
export default Scatter;